/* eslint-disable */

import $ from 'jquery';
import loadingLayer from '../../util/loadingLayer';
import formMessages from '../../util/formMessages';

export default {
    init() {
        formMessages().useCaptcha();
        formMessages('#member-resetpass').validate();

        $('#member-resetpass').on('submit', function(event) {
            event.stopImmediatePropagation();
            event.preventDefault();

            loadingLayer.showLoading();
            const $form = $(this);
            formMessages($form).init();

            const url = $form.attr('action-ajax') || $form.attr('action');
            const method = $form.attr('method');

            const formData = $form.serializeArray();
            const data = {};

            for (var i in formData) {
                data[formData[i].name] = formData[i].value;

                $('#' + formData[i].name, $form).removeClass('is-invalid');
                $('#' + formData[i].name + ' ~ .invalid-feedback', $form).text('');
            }

            $.ajax({
                url,
                method,
                data: {
                    ...data,
                    nonce: window.meta_object.nonce,
                    captcha_token: window.meta_object.captcha_token,
                    action: 'member-resetpass',
                },
                dataType: 'json',
                complete: function() {
                    formMessages().reloadCaptcha();
                },
                success: function(data) {
                    if (!data) {
                        loadingLayer.hideLoading();
                        return;
                    }

                    if (data.success && data.successUrl) {
                        window.location.replace(data.successUrl);
                        return;
                    }

                    loadingLayer.hideLoading();
                    
                    formMessages($form, data).run();
                },
                error: function(err) {
                    loadingLayer.hideLoading();
                }
            });
        });

        formMessages('#member-resetpass-save').validate();
        $('#member-resetpass-save').on('submit', function(event) {
            event.stopImmediatePropagation();
            event.preventDefault();

            loadingLayer.showLoading();
            const $form = $(this);
            formMessages($form).init();

            const url = $(this).attr('action-ajax') || $(this).attr('action');
            const method = $(this).attr('method');

            const formData = $(this).serializeArray();
            const data = {};

            for (var i in formData) {
                data[formData[i].name] = formData[i].value;

                $('#' + formData[i].name, $form).removeClass('is-invalid');
                $('#' + formData[i].name + ' ~ .invalid-feedback', $form).text('');
            }

            $.ajax({
                url,
                method,
                data: {
                    ...data,
                    nonce: window.meta_object.nonce,
                    captcha_token: window.meta_object.captcha_token,
                    action: 'member-resetpass-save',
                },
                dataType: 'json',
                complete: function() {
                    formMessages().reloadCaptcha();
                },
                success: function(data) {
                    if (!data) {
                        loadingLayer.hideLoading();
                        return;
                    }

                    if (data.success && data.successUrl) {
                        window.location.replace(data.successUrl);
                        return;
                    }
                    else if (data.success) {
                        window.location.replace(window.meta_object.login_url);
                        return;
                    }

                    loadingLayer.hideLoading();
                    formMessages($form, data).run();
                },
                error: function(err) {
                    loadingLayer.hideLoading();
                }
            });
        });
    },
    finalize() {

    },
  };
  


// WEBPACK FOOTER //
// ./scripts/routes/blocks/memberResetpass.js